module.exports = __webpack_public_path__ + "img/CryptoTaxSpace_Logo.95cc78f3.png";